import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { STOCKS_TYPES } from 'src/features/stocks/ducks/consts'
import {
  cleanExportOffersDetailsRoutine,
  showExportOfferDetailsRoutine
} from 'src/features/stocks/ducks/actions-export'
import {
  cleanImportOffersDetailsRoutine,
  showImportOfferDetailsRoutine
} from 'src/features/stocks/ducks/actions-import'
import {
  cleanGeneralOffersDetailsRoutine,
  showGeneralOfferDetailsRoutine
} from 'src/features/stocks/ducks/actions-general-cargo'
import {
  cleanPostImportOffersDetailsRoutine,
  showPostImportOfferDetailsRoutine
} from 'src/features/stocks/ducks/actions-post-import'
import {
  cleanFreeCarriersOffersDetailsRoutine,
  showFreeCarrierOfferDetailsRoutine
} from 'src/features/stocks/ducks/actions-free-carriers'
import {
  ExportOfferDetails,
  FreeCarriersOfferDetails,
  GeneralOfferDetails,
  ImportOfferDetails,
  PostImportOfferDetails
} from './index'

const NOOP = () => {}

const OFFER_TYPE_ALIASES = {
  freeCarriers: STOCKS_TYPES.FREE_CARRIERS,
  postImport: STOCKS_TYPES.POST_IMPORT
}

const OFFER_DETAILS_COMPONENTS = {
  [STOCKS_TYPES.CARGO_EXPORT]: ExportOfferDetails,
  [STOCKS_TYPES.CARGO_IMPORT]: ImportOfferDetails,
  [STOCKS_TYPES.GENERAL]: GeneralOfferDetails,
  [STOCKS_TYPES.POST_IMPORT]: PostImportOfferDetails,
  [STOCKS_TYPES.FREE_CARRIERS]: FreeCarriersOfferDetails
}

const OFFER_DETAILS_ACTIONS = {
  [STOCKS_TYPES.CARGO_EXPORT]: showExportOfferDetailsRoutine,
  [STOCKS_TYPES.CARGO_IMPORT]: showImportOfferDetailsRoutine,
  [STOCKS_TYPES.GENERAL]: showGeneralOfferDetailsRoutine,
  [STOCKS_TYPES.POST_IMPORT]: showPostImportOfferDetailsRoutine,
  [STOCKS_TYPES.FREE_CARRIERS]: showFreeCarrierOfferDetailsRoutine
}

const CLEAR_OFFER_DETAILS_ACTIONS = {
  [STOCKS_TYPES.CARGO_EXPORT]: cleanExportOffersDetailsRoutine,
  [STOCKS_TYPES.CARGO_IMPORT]: cleanImportOffersDetailsRoutine,
  [STOCKS_TYPES.GENERAL]: cleanGeneralOffersDetailsRoutine,
  [STOCKS_TYPES.POST_IMPORT]: cleanPostImportOffersDetailsRoutine,
  [STOCKS_TYPES.FREE_CARRIERS]: cleanFreeCarriersOffersDetailsRoutine
}

const OfferHistoryDetails = ({
  defaultOfferType,
  isOpen,
  offerType,
  onActiveOfferChange = NOOP,
  onClose,
  onOfferTypeChange = NOOP,
  selectedOfferId
}) => {
  const dispatch = useDispatch()
  const normalizedDefaultOfferType =
    OFFER_TYPE_ALIASES[defaultOfferType] || defaultOfferType
  const normalizedOfferType = OFFER_TYPE_ALIASES[offerType] || offerType
  const [internalOfferType, setInternalOfferType] = useState(
    normalizedDefaultOfferType
  )
  const previousOpenRef = useRef(isOpen)
  const previousSelectedOfferIdRef = useRef(selectedOfferId)
  const isHistorySelectionRef = useRef(false)
  const activeOfferType = normalizedOfferType || internalOfferType

  useEffect(() => {
    const drawerOpened = isOpen && !previousOpenRef.current
    const selectedOfferChanged =
      isOpen && previousSelectedOfferIdRef.current !== selectedOfferId

    if (
      (drawerOpened || selectedOfferChanged) &&
      !isHistorySelectionRef.current &&
      (!normalizedOfferType ||
        normalizedOfferType === normalizedDefaultOfferType)
    ) {
      setInternalOfferType(normalizedDefaultOfferType)
      if (normalizedOfferType !== normalizedDefaultOfferType) {
        onOfferTypeChange(normalizedDefaultOfferType)
      }
    }

    isHistorySelectionRef.current = false
    previousOpenRef.current = isOpen
    previousSelectedOfferIdRef.current = selectedOfferId
  }, [
    isOpen,
    normalizedDefaultOfferType,
    normalizedOfferType,
    onOfferTypeChange,
    selectedOfferId
  ])

  const handleHistoryOfferSelect = historyOffer => {
    const showOfferDetails = OFFER_DETAILS_ACTIONS[historyOffer.offerType]
    if (!showOfferDetails) return

    isHistorySelectionRef.current = true
    const clearCurrentOfferDetails =
      CLEAR_OFFER_DETAILS_ACTIONS[activeOfferType]
    if (clearCurrentOfferDetails) {
      dispatch(clearCurrentOfferDetails())
    }

    setInternalOfferType(historyOffer.offerType)
    onOfferTypeChange(historyOffer.offerType)
    onActiveOfferChange({
      id: historyOffer.id,
      offerType: historyOffer.offerType
    })
    dispatch(
      showOfferDetails({
        id: historyOffer.id,
        query: { origin: 'drawer' }
      })
    )
  }

  const DetailsComponent =
    OFFER_DETAILS_COMPONENTS[activeOfferType] ||
    OFFER_DETAILS_COMPONENTS[normalizedDefaultOfferType]

  return (
    <DetailsComponent
      onDrawerClose={onClose}
      onHistoryOfferSelect={handleHistoryOfferSelect}
    />
  )
}

export default OfferHistoryDetails
